@let items = widgetData();

<div class="h-full w-full px-3 py-2 overflow-auto">
  @if (items.length > 0) {
    <div class="grid grid-cols-3 w-full gap-3">
      @for (item of items; track $index) {
        <mat-card
          class="overflow-hidden card-item cursor-pointer"
          role="button"
          tabindex="0"
          [attr.aria-label]="'Vai a lista di attesa ' + item.tag + '-' + item.maxGiorniTag + 'gg'"
          (click)="onItemClick(item)"
          (keydown.enter)="onItemClick(item)"
          (keydown.space)="onItemClick(item)"
        >
          <mat-card-content class="p-0">
            <div class="card-body">
              <div class="card-left">
                <span class="scadenza-value"
                  >{{ item.tag }} - {{ item.maxGiorniTag }} gg</span
                >
                <span class="attesa-label"
                  >mediana attesa: {{ item.ritardoMediano }}</span
                >
              </div>
              <span
                class="num-segnalazioni"
                [style.color]="getPercentageColor(item.percentualeInRitardo)"
              >
                {{ item.numSegnalazioni }}
              </span>
            </div>
            <div
              class="progress-bar"
              [style]="getProgressBarStyle(item.percentualeInRitardo)"
            ></div>
            <div class="card-footer">
              <div class="footer-item">
                <span class="footer-label">Scaduti:</span>
                <span class="footer-value"
                  >{{ item.numSegnalazioniRitardo }} ({{
                    item.percentualeInRitardo
                  }}%)</span
                >
              </div>
              <div class="footer-item">
                <span class="footer-label">in attesa:</span>
                <span class="footer-value"
                  >{{ item.numSegnalazioni - item.numSegnalazioniRitardo }} ({{
                    100 - item.percentualeInRitardo
                  }}%)</span
                >
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  } @else {
    <p class="flex justify-center items-center w-full h-full text-sm m-0">
      Nessun dato da visualizzare
    </p>
  }
</div>
